var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00007 8.67073C10.2572 8.67073 11.2763 7.63783 11.2763 6.36369C11.2763 5.08954 10.2572 4.05664 9.00007 4.05664C7.74296 4.05664 6.72388 5.08954 6.72388 6.36369C6.72388 7.63783 7.74296 8.67073 9.00007 8.67073Z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5523 9.98911C14.4503 9.98911 15.1782 9.25133 15.1782 8.34123C15.1782 7.43114 14.4503 6.69336 13.5523 6.69336C12.6544 6.69336 11.9265 7.43114 11.9265 8.34123C11.9265 9.25133 12.6544 9.98911 13.5523 9.98911Z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.494 9.98911C5.39192 9.98911 6.11983 9.25133 6.11983 8.34123C6.11983 7.43114 5.39192 6.69336 4.494 6.69336C3.59607 6.69336 2.86816 7.43114 2.86816 8.34123C2.86816 9.25133 3.59607 9.98911 4.494 9.98911Z",
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00015 9.33008C6.66933 9.33008 4.77295 11.2522 4.77295 13.6146C4.77295 13.7965 4.91863 13.9442 5.09813 13.9442H12.9022C13.0817 13.9442 13.2274 13.7965 13.2274 13.6146C13.2274 11.2522 11.331 9.33008 9.00015 9.33008Z",
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05452 10.7196C4.85552 10.6768 4.65325 10.6484 4.44776 10.6484C2.83427 10.6484 1.52124 11.9793 1.52124 13.6146C1.52124 13.7966 1.66693 13.9442 1.84642 13.9442H4.18242C4.14599 13.8407 4.12258 13.7306 4.12258 13.6146C4.12258 12.533 4.47117 11.5343 5.05452 10.7196Z",
    fill: "#FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5523 10.6484C13.3468 10.6484 13.1446 10.6768 12.9456 10.7196C13.5289 11.5343 13.8775 12.533 13.8775 13.6146C13.8775 13.7306 13.8541 13.8407 13.8177 13.9442H16.1537C16.3331 13.9442 16.4788 13.7966 16.4788 13.6146C16.4788 11.9793 15.1658 10.6484 13.5523 10.6484Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.70b159e1bf9fa896c714656d444d052e.svg";
export { ForwardRef as ReactComponent };